import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from 'buefy';


const axios = require('axios');

Vue.use(Buefy);
Vue.config.productionTip = false;

// Load the full build.
var _ = require('lodash');

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    loggedin: false,
  },
  mounted: function () {

    // Hash-Mode Router robuster machen: nach Backend-Redirect auf "/"
    // sicherstellen, dass die App im erwarteten #/ Pfad landet.
    if (!window.location.hash) {
      window.location.hash = '/';
    }

	//Toggle Mobile-Nav Menu
    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {

      // Get the target from the "data-target" attribute
      var target = $el.dataset.target;
      var $target = document.getElementById(target);

      // Toggle the class on both the "navbar-burger" and the "navbar-menu"
      $el.classList.toggle('is-active');
      $target.classList.toggle('is-active');

      });
    });
    }


    //Check for Login
    this.$store.dispatch('setOauthErrorFromLocation');
    console.log("checkForLogin");
    this.$store.dispatch('checkForLogin').then(() => {
      // Nach Redirects (z.B. OAuth Callback) kann ein kurzer Retry helfen,
      // falls die Session im Browser noch nicht sofort verfügbar ist.
      if (!this.$store.state.loggedin) {
        setTimeout(() => {
          this.$store.dispatch('checkForLogin');
        }, 500);
      }
    });

  }
}).$mount("#app");
